
export default {
  "assets": "https://okta-static-files-preview.ecm.underarmour.com/sbx2"
}
	